import { ICoresAvulco } from "shared/interface/itensAvulsos";
import webApi from "../../webapi";

export const getCoresById = async (id: number) => {
	const data: ICoresAvulco = await webApi.get(`/api/Cor/${id}`);
	return data;
};
